import api from "../../index";
import { configurationVariables } from "../../../environment/index";

export const getAvisoAntiGolpe = async (idCliente) => {
  try {
    const { data: response, status } = await api.get(
      "/carrinhoGeral/GetAvisoAntiGolpe"
    );

    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data,
    };
  } catch (error) {
    throw new Error(error + "JCNAS");
  }
};
